import { RawUserPersonalInfoModel } from "../user_personal_info_model.js";

class RawAdminUserBirthInfoModel extends RawUserPersonalInfoModel {

  formFieldsWhitelist(item=undefined) {
    return ["birthDate", "birthPlace"]
  }

}
const AdminUserBirthInfoModel = new RawAdminUserBirthInfoModel();

export { RawAdminUserBirthInfoModel, AdminUserBirthInfoModel }
